export default class ShareOverlay {
    constructor(el) {
        this.el = el;
        this.overlay = this.el.querySelector('.share-overlay__fade');
        this.closeButton = this.el.querySelector('.share-overlay__close');
        let closeBinding = event => this.closeOverlay();
        this.overlay.addEventListener('click', closeBinding);
        this.closeButton.addEventListener('click', closeBinding);
    }

    open() {
        this.el.classList.add('share-overlay--show');
    }

    closeOverlay() {
        this.el.classList.remove('share-overlay--show');
    }
};